import React, { useContext } from 'react';
import MediaQuery, { useMediaQuery } from 'react-responsive';

import {
  LuPlayCircle,
  LuCreditCard,
  LuGamepad2,
  LuShoppingCart,
  LuGlobe2,
  LuHeadphones,
} from 'react-icons/lu';

import {
  VertContainer,
  VertTypography,
  Col,
  Row,
  VertTokens,
} from '@vertem-core/vertice-ds';


import 'Assets/styles/default/components/LikePlus/LikePlusAbout.less';
import 'Assets/styles/default/components/LikePlus/LikePlusGeneric.less';

import Icon from 'components/Atoms/Icons/Icon';
import LikePlusRules from 'components/LikePlus/LikePlusRules';

import { cardCustomLabel, cardImgUrl, hasWithdrawal } from 'Constants/LikePlus';

const LikePlusAbout = () => {
  const isLargeScreen = useMediaQuery({ minWidth: 769 });

  return (
    <VertContainer fluid={true} className="like-plusabout margin-y-big">
      <VertContainer>
        <Row gutter={0}>
          <Col
            className={`like-plus-how-work col-12 margin-bottom-regular vert-bg-light-lighter border-radius-large vert-bordered border-color-highlight ${isLargeScreen ? 'border-left-large' : 'border-top-large'
              }`}
          >
            <Row gutter={0} align={`middle`}>
              <Col className="col-12 col-md-auto card-img-likemais">
                <MediaQuery minWidth={769}>
                  <img
                    className="h-100 d-block"
                    alt="Ilustração do cartão like-mais"
                    src={cardImgUrl}
                    style={{ maxWidth: '301px', marginLeft: '5px' }}

                    aria-hidden={true}
                  />
                </MediaQuery>
                <MediaQuery maxWidth={768} >
                  <img
                    className="h-100 w-100 d-block"
                    alt="Ilustração do cartão like-mais"
                    src={cardImgUrl}
                    style={{ maxWidth: '360px', marginTop: '15px' }}
                    aria-hidden={true}
                  />
                </MediaQuery>
              </Col>
              <Col className="col padding-x-regular  padding-y-regular">
                <Row gutter={0}>
                  <Col className="col-12">
                    <VertTypography.Title
                      type="default"
                      level={1}
                      className="font-w-600 margin-bottom-regular"
                    >
                      Como funciona o cartão {cardCustomLabel}?
                    </VertTypography.Title>
                  </Col>
                  <Col className="col-12">
                    <Row align="middle" justify="center" gutter={24}>
                      <Col className="col-12 col-md-4 padding-y-extra-small">
                        <Row align="top" className="h-100">
                          <Col className="col-auto col-md-12 col-xl-auto padding-left-none padding-right-extra-small padding-bottom-extra-small">
                            <span className="vert-bg-detached tag-rounded">
                              1
                            </span>
                          </Col>
                          <Col className="col">
                            <VertTypography.Title
                              type="detached"
                              level={2}
                              className="font-w-600"
                            >
                              Faça a primeira recarga
                            </VertTypography.Title>
                            <VertTypography.Paragraph className="txt-paragraph font-w-500">
                              Vá no link{' '}
                              <strong className="color-detached">
                                Peça o seu
                              </strong>{' '}
                              e troque pontos por saldo no cartão.
                            </VertTypography.Paragraph>
                          </Col>
                        </Row>
                      </Col>
                      <Col className="col-12 col-md-4 padding-y-extra-small">
                        <Row align="top" className="h-100">
                          <Col className="col-auto col-md-12 col-xl-auto padding-left-none padding-right-extra-small padding-bottom-extra-small">
                            <span className="vert-bg-detached tag-rounded">
                              2
                            </span>
                          </Col>
                          <Col className="col">
                            <VertTypography.Title
                              type="detached"
                              level={2}
                              className="font-w-600"
                            >
                              Aguarde seu cartão
                            </VertTypography.Title>
                            <VertTypography.Paragraph className="txt-paragraph font-w-500">
                              Após a primeira recarga, enviamos o cartão pra
                              você.
                            </VertTypography.Paragraph>
                          </Col>
                        </Row>
                      </Col>
                      <Col className="col-12 col-md-4 padding-y-extra-small">
                        <Row align="top" className="h-100">
                          <Col className="col-auto col-md-12 col-xl-auto padding-left-none padding-right-extra-small padding-bottom-extra-small">
                            <span className="vert-bg-detached tag-rounded">
                              3
                            </span>
                          </Col>
                          <Col className="col">
                            <VertTypography.Title
                              type="detached"
                              level={2}
                              className="font-w-600"
                            >
                              Aproveite!
                            </VertTypography.Title>
                            <VertTypography.Paragraph className="txt-paragraph font-w-500">
                              Faça suas compras e adicione créditos quando
                              precisar.
                            </VertTypography.Paragraph>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col
            className={`like-plus-where-use col-12 margin-bottom-regular vert-bg-detached border-radius-large vert-bordered border-color-highlight ${isLargeScreen ? 'border-right-large' : 'border-bottom-large'
              }`}
          >
            <Row
              gutter={0}
              align={`middle`}
              className="padding-x-regular padding-y-regular"
            >
              <Col className="col-12">
                <VertTypography.Title
                  type='white'
                  level={2}
                  className="font-w-600"
                >
                  Onde usar o cartão?
                </VertTypography.Title>
              </Col>
              <Col className="col-12">
                <Row gutter={24} justify="center" type="flex">
                  <Col className="col-6 col-md-4 col-xl text-center padding-y-regular">
                    <Icon
                      className="where-use-icon lucide white-icon"
                      size={`50px`}
                      component={LuCreditCard}
                    />
                    <VertTypography.Paragraph
                      type='white'
                      className="txt-paragraph font-w-600 w-100 text-center margin-top-small"
                    >
                      Estabelecimentos <br />
                      da rede MasterCard
                    </VertTypography.Paragraph>
                  </Col>
                  <Col className="col-6 col-md-4 col-xl text-center padding-y-regular">
                    <Icon
                      className="where-use-icon lucide white-icon"
                      size={`50px`}
                      component={LuPlayCircle}
                    />
                    <VertTypography.Paragraph
                      type='white'
                      className="txt-paragraph font-w-600 w-100 text-center margin-top-small"
                    >
                      Serviços de streaming <br />
                      por assinatura
                    </VertTypography.Paragraph>
                  </Col>
                  <Col className="col-6 col-md-4 col-xl text-center padding-y-regular">
                    <Icon
                      className="where-use-icon lucide white-icon"
                      size={`50px`}
                      component={LuGamepad2}
                    />
                    <VertTypography.Paragraph
                      type='white'
                      className="txt-paragraph font-w-600 w-100 text-center margin-top-small"
                    >
                      Assinaturas e compras <br />
                      de games
                    </VertTypography.Paragraph>
                  </Col>
                  <Col className="col-6 col-md-4 col-xl text-center padding-y-regular">
                    <Icon
                      className="where-use-icon lucide white-icon"
                      size={`50px`}
                      component={LuShoppingCart}
                    />
                    <VertTypography.Paragraph
                      type='white'
                      className="txt-paragraph font-w-600 w-100 text-center margin-top-small"
                    >
                      Supermercados
                    </VertTypography.Paragraph>
                  </Col>
                  <Col className="col-6 col-md-4 col-xl text-center padding-y-regular">
                    <Icon
                      className="where-use-icon lucide white-icon "
                      size={`50px`}
                      component={LuGlobe2}
                    />
                    <VertTypography.Paragraph
                      type='white'
                      className="txt-paragraph font-w-600 w-100 text-center margin-top-small"
                    >
                      Compras em qualquer <br />
                      site do Brasil
                    </VertTypography.Paragraph>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </VertContainer>
      <VertContainer className="like-plus-benefits col-12 margin-bottom-regular vert-bg-light-lighter border-radius-large ">
        <Row
          gutter={0}
          align={`middle`}
          className="padding-x-regular padding-y-regular"
        >
          <Col className="col-12">
            <VertTypography.Title
              type="default"
              level={1}
              className="font-w-600 margin-bottom-regular"
            >
              Confira as vantagens do cartão {cardCustomLabel}
            </VertTypography.Title>
          </Col>
          <Col className="col-12">
            <Row gutter={0}>

              {hasWithdrawal && (
                <Col className="col-12 col-md-6 col-xl-3 margin-y-extra-small padding-x-extra-small">

                  <Row gutter={0}>
                    <Col className="col-12 vert-bg-white padding-y-small padding-x-small border-radius-large">
                      <VertTypography.Paragraph
                        type="default"
                        className="txt-paragraph font-w-600 w-100 text-left margin-top-small"
                      >
                        Saque no caixa eletrônico
                      </VertTypography.Paragraph>


                      <VertTypography.Paragraph
                        type="default"
                        className="txt-paragraph font-w-400 w-100 text-left margin-top-small"
                      >
                        Saque o saldo da sua conta em caixas da rede Banco24Horas
                        e da rede Cirrus.
                      </VertTypography.Paragraph>
                    </Col>
                  </Row>
                </Col>

              )}

              <Col className="col-12 col-md-6 col-xl-3 margin-y-extra-small padding-x-extra-small">
                <Row gutter={0}>
                  <Col className="col-12 vert-bg-white padding-y-small padding-x-small border-radius-large">
                    <VertTypography.Paragraph
                      type="default"
                      className="txt-paragraph font-w-600 w-100 text-left margin-top-small"
                    >
                      Recarga fácil
                    </VertTypography.Paragraph>
                    <VertTypography.Paragraph
                      type="default"
                      className="txt-paragraph font-w-400 w-100 text-left margin-top-small"
                    >
                      Recarregue seu cartão utilizando seus pontos
                    </VertTypography.Paragraph>
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-md-6 col-xl-3 margin-y-extra-small padding-x-extra-small">
                <Row gutter={0}>
                  <Col className="col-12 vert-bg-white padding-y-small padding-x-small border-radius-large">
                    <VertTypography.Paragraph
                      type="default"
                      className="txt-paragraph font-w-600 w-100 text-left margin-top-small"
                    >
                      Compras ilimitadas
                    </VertTypography.Paragraph>
                    <VertTypography.Paragraph
                      type="default"
                      className="txt-paragraph font-w-400 w-100 text-left margin-top-small"
                    >
                      Compre quantas vezes quiser. Não há limite diário de
                      transações.
                    </VertTypography.Paragraph>
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-md-6 col-xl-3 margin-y-extra-small padding-x-extra-small">
                <Row gutter={0}>
                  <Col className="col-12 vert-bg-white padding-y-small padding-x-small border-radius-large">
                    <VertTypography.Paragraph
                      type="default"
                      className="txt-paragraph font-w-600 w-100 text-left margin-top-small"
                    >
                      Aceito em todo o Brasil
                    </VertTypography.Paragraph>
                    <VertTypography.Paragraph
                      type="default"
                      className="txt-paragraph font-w-400 w-100 text-left margin-top-small"
                    >
                      Compre online ou em lojas físicas, em toda a rede
                      Mastercard.
                    </VertTypography.Paragraph>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </VertContainer>
      <VertContainer>
        <Row
          gutter={0}
          align={`middle`}
          className="padding-x-regular padding-y-regular"
        >
          <Col className="col-12">
            <LikePlusRules />
          </Col>
          <Col className="col-12 margin-top-small">
            <Row gutter={0} align={`middle`}>
              <Col className="col-auto margin-right-extra-small">
                <Icon
                  className="where-use-icon lucide color-neutral-dark"
                  size={`24px`}
                  component={LuHeadphones}
                />
              </Col>
              <Col className="col">
                <VertTypography.Paragraph
                  type="default"
                  className="txt-medium font-w-600 w-100 text-left"
                >
                  4020-0221
                </VertTypography.Paragraph>
              </Col>
            </Row>
          </Col>
        </Row>
      </VertContainer>
    </VertContainer>
  );
};

export default LikePlusAbout;
